import { Link } from "react-router-dom";
import { genreList } from "@/mocks/movies";
import { newsCategories } from "@/mocks/news";

const friendLinks = [
  { label: "经典电影资料馆", href: "/category" },
  { label: "影视资讯频道", href: "/news" },
  { label: "经典专题精选", href: "/specials" },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-film-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl font-black">80s电影</span>
          </div>
          <p className="mt-4 font-label text-sm leading-relaxed text-background-300">
            专注80年代经典电影资源与影视资讯，记录那个银幕灿烂的十年。本站内容为演示展示。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            电影类型
          </h4>
          <ul className="mt-4 space-y-2">
            {genreList.slice(0, 6).map((genre) => (
              <li key={genre}>
                <Link
                  to={`/category?genre=${encodeURIComponent(genre)}`}
                  className="font-label text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {genre}片
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            资讯栏目
          </h4>
          <ul className="mt-4 space-y-2">
            {newsCategories.map((cat) => (
              <li key={cat}>
                <Link
                  to={`/news?category=${encodeURIComponent(cat)}`}
                  className="font-label text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {cat}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            友情链接
          </h4>
          <ul className="mt-4 space-y-2">
            {friendLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="font-label text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 font-label text-xs text-background-400 sm:flex-row md:px-6">
          <p>© 2024 80s电影 · 怀旧光影资料站（演示项目）</p>
          <p>本站所有影片资料与评论均为演示内容</p>
        </div>
      </div>
    </footer>
  );
}